export default __webpack_public_path__ + "static/media/pita_chips_2.b8550281.jpg";